import { Component, Input, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { GlobalService } from '../../services/global/global.service';

@Component({
  selector: 'app-person-options',
  templateUrl: './person-options.component.html',
  styleUrls: ['./person-options.component.scss'],
})
export class PersonOptionsComponent implements OnInit {

  @Input() leadDetails: any;
  @Input() onPathSelected!: (data: any) => void;

  @Input() showInvoice: any;
  showCreateQuoteButton: any;
  hideLeadEditButton: any;
  hideCreateTask: any;
  createInvoice: any;

  constructor(
    private _popoverController: PopoverController,
    private _globalService: GlobalService
  ) { }

  ngOnInit() {
    this._globalService.roles$.subscribe((roles) => {
      const leadModule = roles?.modules.find((module: any) => module.name === "Leads");
      this.hideLeadEditButton = leadModule?.permissions?.editLead

      const taskModule = roles.modules.find((module: any) => module.name === "Tasks");
      if (!taskModule || !taskModule.permissions) {
        this.hideCreateTask = true;
      } else {
        this.hideCreateTask = taskModule.permissions.createTask;
      }

      const invoiceModule = roles.modules.find((module: any) => module.name === "Invoice & Receipts");
        if (!invoiceModule || !invoiceModule.permissions) {
          this.createInvoice = true;  // Set to true if taskModule is null or undefined
        } else {
          this.createInvoice = invoiceModule.permissions.createInvoice;
        }

    })
  }

  dismiss() {
    this._popoverController.dismiss();
  }

  routeToPath(path: any) {
    this.onPathSelected({ path: path });
    this.dismiss()
  }

}
